// Modern JP mockup interactions (vanilla JS, no dependencies)
(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  // toast for placeholder links
  const toast=document.createElement('div');toast.className='toast';document.body.appendChild(toast);
  let tt;function say(m){toast.textContent=m;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(()=>toast.classList.remove('show'),2200)}
  const AMZ=window.AMZ_LINKS||{};
  const amz=a=>{const k=a.dataset.amzKey||(a.dataset.amzKey=a.getAttribute('href').slice(8));const u=(a.dataset.sku&&AMZ[a.dataset.sku])||AMZ[k]||AMZ.STORE;if(u){a.href=u;a.target='_blank';a.rel='noopener sponsored'}};
  window.__amz=amz;$$('a[href^="#amazon"]').forEach(amz);
  $$('a[href="#"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();0}));

  // gallery
  const stage=$('#stage-img');
  if(stage){
    const thumbs=$$('.thumbs button');let idx=0;
    const show=i=>{idx=(i+thumbs.length)%thumbs.length;const b=thumbs[idx];stage.src=b.dataset.src;
      thumbs.forEach(t=>t.classList.toggle('on',t===b));$('#counter').textContent=(idx+1)+' / '+thumbs.length;
      b.scrollIntoView({block:'nearest',inline:'nearest'})};
    thumbs.forEach((b,i)=>b.addEventListener('click',()=>show(i)));
    $('#prev').addEventListener('click',()=>show(idx-1));$('#next').addEventListener('click',()=>show(idx+1));
    // variant selection
    const P=window.PRODUCT;if(!P)return;let color=P.defaultColor,pack=P.defaultPack;
    const update=()=>{const key=P.code+'-'+color[0]+'-'+pack;const asin=P.asins[key]||'not listed on Amazon';
      $('#sel-color').textContent=color;$('#sel-pack').textContent=pack+'-pack';
      $$('.js-amz').forEach(a=>{a.dataset.sku=key;window.__amz(a)});
      0&&('Mockup note: this selection links to Amazon listing '+key+' · ASIN '+asin+'');
      $$('.pack').forEach(p=>{const ok=!!P.asins[P.code+'-'+color[0]+'-'+p.dataset.pack];p.disabled=!ok;p.style.opacity=ok?1:.35})};
    $$('.swatch').forEach(s=>s.addEventListener('click',()=>{color=s.dataset.color;
      $$('.swatch').forEach(x=>x.classList.toggle('on',x===s));stage.src=s.dataset.src;
      thumbs.forEach(t=>t.classList.remove('on'));$('#counter').textContent=color;
      if(!P.asins[P.code+'-'+color[0]+'-'+pack]){pack=P.packs.find(p=>P.asins[P.code+'-'+color[0]+'-'+p]);$$('.pack').forEach(x=>x.classList.toggle('on',+x.dataset.pack===pack))}
      update()}));
    $$('.pack').forEach(p=>p.addEventListener('click',()=>{if(p.disabled)return;pack=+p.dataset.pack;$$('.pack').forEach(x=>x.classList.toggle('on',x===p));update()}));
    update();
    $$('.video').forEach(v=>v.addEventListener('click',()=>0));
  }
  // collection filter
  $$('.coll-tabs .pill[data-filter]').forEach(p=>p.addEventListener('click',()=>{
    const f=p.dataset.filter;$$('.coll-tabs .pill[data-filter]').forEach(x=>x.classList.toggle('on',x===p));
    let n=0;$$('.grid .card').forEach(c=>{const ok=f==='all'||c.dataset.tags.includes(f);c.style.display=ok?'':'none';if(ok)n++});
    $('#count').textContent=n+(n===1?' product':' products')}));
})();

(function(){var b=document.querySelector('.menu-btn');if(!b)return;b.addEventListener('click',function(){var n=b.closest('.nav');var o=n.classList.toggle('open');b.setAttribute('aria-expanded',o)})})();
